import React from 'react';
import { KFLSpinner } from '@kamstrup/kamstrup-frontend-library';
import './spinner.scss';

export enum SpinnerModeEnum {
  'Horizontal' = 'Horizontal',
  'Vertical' = 'Vertical',
}
export type spmode = keyof typeof SpinnerModeEnum;
export type SpinnerMode = spmode; // 'Horizontal' | 'Vertical';

export interface SpinnerBaseProps {
  mode?: SpinnerMode;
  iconSize?: number;
  isReverse?: boolean;
}
export interface SpinnerProps extends SpinnerBaseProps {
  label?: string;
}

const SpinnerBase: React.FC<SpinnerProps> = (props) => {
  const mode = props.mode || 'Horizontal';
  const label = props.label || 'loading';
  const iconSize = props.iconSize || 20;
  const fontSize = `${iconSize * 0.9}px`;
  const height = `${iconSize}px`;
  const classes = `spinner${props.isReverse ? ' reverse' : ''}`;
  return (
    <div className={classes} style={{ fontSize }}>
      {mode === 'Horizontal' ? (
        <>
          <KFLSpinner height={iconSize} width={iconSize} />
          <div className="h-container">
            <span style={{ height }}>{label}</span>
          </div>
        </>
      ) : (
        <KFLSpinner height={iconSize} width={iconSize} text={label} />
      )}
    </div>
  );
};

export default SpinnerBase;
